var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("footer", { staticClass: "footer" }, [
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "content has-text-centered" }, [
        _c(
          "p",
          [
            _vm._v(" © DailyCare Pty Ltd · "),
            _c(
              "a",
              {
                attrs: {
                  href: "https://www.dailycare.com.au/terms-of-use/",
                  target: "_blank",
                  rel: "noreferrer",
                },
              },
              [_vm._v("Terms of use")]
            ),
            _vm._v(" · "),
            _c(
              "a",
              {
                attrs: {
                  href: "https://www.dailycare.com.au/privacy-policy/",
                  target: "_blank",
                  rel: "noreferrer",
                },
              },
              [_vm._v("Privacy policy")]
            ),
            _c("deploy-date"),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }